import React, { useEffect } from "react";
import { CloseIcon } from "../../../Icons";
import { LIBRARIES_BTN, LIBRARIES_MODAL } from "../librariesTheme";

/**
 * Shared Libraries create/edit modal shell (Patient indigo).
 */
const LibraryFormModal = ({
  isOpen,
  title,
  onClose,
  onSubmit,
  isSaving = false,
  children,
  submitLabel = "Save",
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !isSaving) onClose?.();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, isSaving, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className={LIBRARIES_MODAL.backdrop}
      role="dialog"
      aria-modal="true"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !isSaving) onClose?.();
      }}
    >
      <div className={LIBRARIES_MODAL.panel}>
        <div className={LIBRARIES_MODAL.head}>
          <h3 className={LIBRARIES_MODAL.title}>{title}</h3>
          <button
            type="button"
            onClick={onClose}
            disabled={isSaving}
            className={LIBRARIES_MODAL.close}
            aria-label="Close"
          >
            <CloseIcon size={14} />
          </button>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit?.();
          }}
          className="flex flex-col flex-1 min-h-0"
          noValidate
        >
          <div className={LIBRARIES_MODAL.body}>{children}</div>
          <div className={LIBRARIES_MODAL.footer}>
            <button
              type="button"
              onClick={onClose}
              disabled={isSaving}
              className={LIBRARIES_BTN.modalCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSaving}
              className={LIBRARIES_BTN.modalPrimary}
            >
              {isSaving ? "Saving..." : submitLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LibraryFormModal;
